// A member who is no longer here: suspended by an admin, or left on their
// own. Both render muted and sit in no picker; their row stays so the work
// that names them keeps its author.
/** The member statuses a filter offers: everyone who can hold work — invited
 *  and suspended members included, only those who left are not. */
export const FILTER_MEMBER_STATUSES: readonly string[] = ["active", "invited", "suspended"];

export function isFormerMember(user: { memberStatus?: string | null | undefined } | null | undefined): boolean {
  return user?.memberStatus === "suspended" || user?.memberStatus === "left";
}

const STATUS_PRECEDENCE = ["active", "invited", "suspended", "left"];

/** Which of two member rows for one person speaks for them — lower wins: the
 *  live row first (active, then invited), a former one last. Addresses that
 *  differ only by case can name the same person twice. */
export function memberStatusPrecedence(status: string | null | undefined): number {
  const index = STATUS_PRECEDENCE.indexOf(status ?? "");
  return index < 0 ? STATUS_PRECEDENCE.length : index;
}

export function isInvited(user: { memberStatus?: string | null | undefined } | null | undefined): boolean {
  return user?.memberStatus === "invited";
}
